/**
 * System functions
 */
var $ = jQuery;
// detect OS
function detect_os() {
    var os_name = "Unknown OS";
    if (navigator.appVersion.indexOf("Win") != -1) os_name = "Windows";
    if (navigator.appVersion.indexOf("Mac") != -1) os_name = "MacOS";
    if (navigator.appVersion.indexOf("X11") != -1) os_name = "UNIX";
    if (navigator.appVersion.indexOf("Linux") != -1) os_name = "Linux";

    return os_name;
}

// smart replace for templates
String.prototype.replace_all = function(find, replace){
    return this.replace(new RegExp(find, 'g'), replace);
};

// capitalize
String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
}

// helper function to find some value in array of objects
function find_in_array_of_objects(array, key, value){
    var result = false;
    jQuery.each(array, function(index, item){
        if(item.hasOwnProperty(key) && item[key] == value){
            result = true;
        }
    });
    return result;
}

// convert HEX color to RGB color
function hex_to_rgb(hex){
    hex = parseInt(hex, 16);
    var r = hex >> 16;
    var g = hex >> 8 & 0xFF;
    var b = hex & 0xFF;
    return [r,g,b];
}

// check if element visible on screen
$.fn.isVisible = function (parent) {
    var $parent = parent !== 'undefined' ? $(parent) : $(window);
    var windowScrollTopView = $parent.scrollTop();

    var elemTop = $(this).height();
    return (
        elemTop >= windowScrollTopView
    );
};

// check string ends with special characters
String.prototype.endsWith = function(end){
    return this.indexOf(end, this.length - end.length) !== -1;
};

// calculate size properly
var calc_size = function(raw){
    if(raw.endsWith('%') || raw.endsWith('px')){
        return raw;
    }
    var result = raw.replace('/[^0-9]/', '');
    return result + 'px';
};
